import { TDateRange, TFilterScheme } from './models';
import { format, parseISO, isSameDay } from 'date-fns';

/** Небольшие предустановки для фильтров */
export const mapToDefaultFilter = (f: TFilterScheme) => {
  if (f.type === 'options') {
    if (!f.filterField) {
      f.filterField = 'name';
    }
  }
  return f;
};

export const getStringDateRangeValue = (value: TDateRange, showYear?: boolean) => {
  const [first, second] = value || [];
  const defaultFormat = showYear ? 'dd.MM.yyyy' : 'dd.MM';

  const parsedFirst = first && format(parseISO(first), defaultFormat);
  const parsedSecond = second && format(parseISO(second), defaultFormat);

  if (parsedFirst && parsedSecond) {
    return isSameDay(parseISO(first), parseISO(second)) ? parsedFirst : `${parsedFirst} — ${parsedSecond}`;
  }

  const dateFrom = parsedFirst ? `с ${parsedFirst}` : '';
  const dateTo = parsedSecond ? `по ${parsedSecond}` : '';

  return `${dateFrom}${dateFrom && dateTo && ' '}${dateTo}`;
};
